import { Breadcrumb, Col, Row, DatePicker, Button, Select } from "antd";
import Title from "../UI/Title/Title";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { CustomerBalanceList } from "./customerbalanceList";
import { PrinterOutlined } from "@ant-design/icons";
import ResetButton from "../UI/ResetButton/resetbutton";
import { useMutation } from "react-query";
import { getCustomerBalance, getCustomersDropdown } from "../../api/customers";
import { Customer } from "./types";

const CustomerBalance = () => {

  const { RangePicker } = DatePicker;
  const { state } = useLocation();
  const [, setSearchText] = useState("");
  const [tablekey, setTableKey] = useState(1000);
  const [customers, setCustomers] = useState<
    { label: string; value: number }[]
  >([]);
  const [customerBalance, setCustomersBalance] = useState<any>([]);
  const [customer, setCustomer] = useState<any>({
    label: state?.name,
    value: state?.id,
  });
  const [from, setFrom] = useState<string>("");
  const [to, setTo] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const { t } = useTranslation("common");

  const { mutateAsync: getCustomersMutation } = useMutation(
    "customers",
    getCustomersDropdown,
    {
      onSuccess: (result) => {
        const data = result?.data;
        setCustomers(
          data.map((customer: Customer) => {
            return { value: customer.id, label: customer.name };
          })
        );
        !state && setCustomer({ label: data[0].name, value: data[0].id });
      },
    }
  );
  const { mutateAsync: getCustomerBalanceMutation, isLoading: customerBalanceLoading } = useMutation(
    "customerBalance",
    () => getCustomerBalance(customer?.value, page * 10 + 10, from, to),
    {
      onSuccess: (result) => {
        setCustomersBalance(result?.data?.data);
      },
    }
  );

  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setSearchText("");
    setFrom("");
    setTo("");
  };

  useEffect(() => {
    getCustomersMutation();
  }, [getCustomersMutation]);

  useEffect(() => {
    customer?.value && getCustomerBalanceMutation();
  }, [customer?.value, from, getCustomerBalanceMutation, to]);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("customers-transactions")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("customer's-transactions")}
                  </span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          {customer?.label && (
            <Title title={`${customer?.label} ${t("transactions")}`} />
          )}
        </Col>

        <Col offset={1} span={5}>
          <RangePicker
            key={tablekey}
            style={{ width: "100%" }}
            size="large"
            onChange={(date, dateString) => {
              setFrom(dateString[0]);
              setTo(dateString[1]);
            }}
            format={"MM/DD/YYYY"}
          />
        </Col>
        <Col
          span={3}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          {customer?.value && (
            <Select
              key={tablekey}
              defaultValue={customer?.value}
              style={{ width: "100%", height: "40px" }}
              onChange={(v, record) => {
                setCustomer(record);
              }}
              options={customers}
              size="large"
              placeholder={`${t("select-customer")}`}
            />
          )}
        </Col>
        <Col
          offset={12}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Button
            type="text"
            icon={<PrinterOutlined style={{ fontSize: "22px" }} />}
          />
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
        </Col>
        <Col offset={1} span={22}>
          <CustomerBalanceList
            customerBalance={customerBalance}
            customerBalanceLoading={customerBalanceLoading}
            page={page}
            setPage={setPage}
            getCustomerBalanceMutation={getCustomerBalanceMutation}
            setCustomersBalance={setCustomersBalance}
            tablekey={tablekey}
          />
        </Col>
      </Row>
    </>
  );
}

export default CustomerBalance;
